import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search, X } from "lucide-react";
import { Icon } from "../icons.js";
/**
 * The field box carries `data-field`, and `interactions.css` draws the focus ring on it while
 * the input has focus: the inner input keeps `outline: none` inline, since no rule sets that
 * element's outline (ADR 0036 clause 10). The clear × rings itself, not the box.
 */
export function Input({ value, onChange, placeholder, leading, search = false, trailing, onClear, clearLabel = "Clear", disabled = false, style, ...rest }) {
    const lead = leading ?? (search ? _jsx(Icon, { icon: Search, size: 18 }) : null);
    return (_jsxs("div", { "data-field": "", style: {
            display: "flex", alignItems: "center", gap: "var(--space-1)",
            height: 36, padding: "0 14px", borderRadius: "var(--radius-control)",
            background: "var(--tone)", color: "var(--ink-2)",
            opacity: disabled ? 0.6 : 1,
            ...style,
        }, children: [lead && _jsx("span", { style: { display: "inline-flex", flex: "none" }, children: lead }), _jsx("input", { value: value, onChange: onChange, placeholder: placeholder, disabled: disabled, style: {
                    flex: 1, minWidth: 0, background: "transparent", border: "none", outline: "none",
                    padding: 0, color: "var(--ink-1)", fontFamily: "var(--font-sans)",
                    fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                }, ...rest }), onClear && (_jsx("button", { type: "button", "data-field-clear": "", "aria-label": clearLabel, onClick: onClear, style: {
                    display: "inline-grid", placeItems: "center", flex: "none", padding: 0,
                    width: 24, height: 24, margin: "0 calc(var(--space-075) * -1) 0 0",
                    border: "none", background: "transparent", cursor: "pointer",
                    color: "var(--field-clear-ink, var(--ink-2))", borderRadius: "var(--radius-inline)",
                }, children: _jsx(Icon, { icon: X, size: 16 }) })), trailing] }));
}
